/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type I18nLabelCanonicalInput = {
  locale: string;
  value: string;
};

export type I18nLabelInput = {
  canonical?: Array<I18nLabelCanonicalInput> | null | undefined;
  en?: string | null | undefined;
  ja?: string | null | undefined;
};

export type PropertyAttributeTypeId =
  | 'date'
  | 'endDate'
  | 'title';

export type PropertySchemaAssociationInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name: string;
  position?: number | null | undefined;
  propertyAttributeTypeId?: PropertyAttributeTypeId | null | undefined;
  propertySchema: PropertySchemaUpsertInput;
  required?: boolean | null | undefined;
  unique?: boolean | null | undefined;
};

export type PropertySchemaSetUpsertInput = {
  id?: string | null | undefined;
  schemas: Array<PropertySchemaAssociationInput>;
};

export type PropertySchemaType =
  | 'bool'
  | 'dag'
  | 'date'
  | 'formula'
  | 'gdtf'
  | 'i18nLabel'
  | 'i18nLabels'
  | 'linkEntities'
  | 'linkEntity'
  | 'linkGeoItems'
  | 'linkRelation'
  | 'linkRelations'
  | 'media'
  | 'multiSelect'
  | 'number'
  | 'numbers'
  | 'rollup'
  | 'select'
  | 'string'
  | 'strings'
  | 'url';

export type PropertySchemaUpsertInput = {
  id?: string | null | undefined;
  propertyTypeId: PropertySchemaType;
  propertyValueDagId?: string | null | undefined;
  propertyValueLinkFilterId?: string | null | undefined;
  selectOptions?: Array<PropertySelectOptionInput> | null | undefined;
  urlAllowList?: Array<PropertyUrlAllowListItem> | null | undefined;
};

export type PropertySelectOptionInput = {
  id?: string | null | undefined;
  label?: I18nLabelInput | null | undefined;
  value: string;
};

export type PropertyUrlAllowListItem = {
  id?: string | null | undefined;
  regex?: string | null | undefined;
  value?: string | null | undefined;
};

export type RecordComposerDefinitionUpsertInput = {
  definition: Types.JsonObject;
  evidenceSetIds?: Array<string> | null | undefined;
  id?: string | null | undefined;
  importProjectId?: string | null | undefined;
  name: string;
  propertySchemaSet: PropertySchemaSetUpsertInput;
  tenantId: string;
};

export type UpsertEntityComposerDefinitionMutationVariables = Exact<{
  input: Types.RecordComposerDefinitionUpsertInput;
}>;


export type UpsertEntityComposerDefinitionMutation = { cnutUpsertEntityComposerDefinition:
    | { __typename: 'RecordComposerDefinitionUpsertOutput', id: string }
    | { __typename: 'ValidationError', code: string, message: string, fields: Array<{ __typename: 'ValidationErrorField', code: string | null, message: string }> }
   };


export const UpsertEntityComposerDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertEntityComposerDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordComposerDefinitionUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpsertEntityComposerDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecordComposerDefinitionUpsertOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertEntityComposerDefinitionMutation, UpsertEntityComposerDefinitionMutationVariables>;